module.exports = __webpack_public_path__ + "media/images/forms/form-validation-valid-c65d2c28c0490fc8d1e6620cc4cf93fd.svg";